module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "userinfo"
    }
  }, [_c('h1', [_vm._v("ユーザー情報")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "user_information",
      "border": "1"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "cate1"
  }, [_vm._v("\n          名前\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          :\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.$store.state.userInfo.fullname) + "（" + _vm._s(_vm.userType) + "）\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "cate1"
  }, [_vm._v("ユーザー名(ID)")]), _vm._v(" "), _c('td', [_vm._v("\n          :\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$store.state.userInfo.user_name))])])])]), _vm._v(" "), (_vm.$store.state.userInfo.user_type !== 'viewer') ? _c('div', [_c('password-change-panel', {
    attrs: {
      "user_id": _vm.$store.state.userInfo.user_id
    }
  }), _vm._v(" "), _c('user-name-change-panel', {
    attrs: {
      "user_id": _vm.$store.state.userInfo.user_id,
      "current_user_name": _vm.$store.state.userInfo.user_name
    },
    on: {
      "changed": function($event) {
        _vm.getUserInfo()
      }
    }
  }), _vm._v(" "), _c('mail-address-change-panel', {
    attrs: {
      "user_id": _vm.$store.state.userInfo.user_id,
      "current_mail": _vm.$store.state.userInfo.mail_address
    }
  }), _vm._v(" "), _c('status-change-panel', {
    attrs: {
      "user_id": _vm.$store.state.userInfo.user_id,
      "current_status": _vm.$store.state.userInfo.status
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "square_btn1",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.getinformation
    }
  }, [_vm._v("OK")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0af810e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserInfo/UserInfoPage.vue
// module id = 666
// module chunks = 0